<template>
	<div v-if="isSending" class="sending-container">
		<img class="image" src="undefined" />
	</div>
	<div @click="handleImageView(message)" v-else-if="isSuccess || isFailed" class="image-container">
		<img class="image" :src="computedSrc" :key="computedSrc" alt="image" />
	</div>
</template>

<script>
export default {
	name: "ChatMessageImage",
	props: {
		message: {
			type: Object,
			required: true,
		},
	},
	data() {
		return {
			localStatus: this.message._status,
		};
	},
	watch: {
		"message.attachment_url"(newUrl) {
			if (newUrl) {
				this.localStatus = 1;
			}
		},
	},
	computed: {
		// 消息发送状态
		isSending() {
			return this.message._status === 0;
		},
		isSuccess() {
			return this.message._status === 1 || this.message._status === undefined;
		},
		isFailed() {
			return this.message._status === 2;
		},

		computedSrc() {
			// 优先使用后端签名的缩略图（处理参数已签入）；
			// OSS 私有化后禁止在返回的 URL 上追加 x-oss-process 等参数（会破坏签名导致 403）
			return this.message.attachment_thumbnail_url || this.message.attachment_url || "";
		},
	},
	methods: {
		handleImageView(message) {
			this.$emit("handle-image-view", message);
		},
	},
};
</script>

<style lang="less" scoped>
.sending-container,
.image-container {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 150px;
	height: 150px;
	background-color: #f5f5f5;
}

.image-container {
	cursor: pointer;
	background-color: transparent;
}

.image {
	display: block;
	max-width: 100%;
	max-height: 100%;
	cursor: pointer;
	background-color: #d3d3d3;
	object-fit: contain;
}

.image-container .image {
	width: 150px;
	height: 150px;
	object-fit: cover;
}
</style>
